import { render } from "./AddressAutofillList.vue?vue&type=template&id=f63176e6"
import script from "./AddressAutofillList.vue?vue&type=script&lang=js"
export * from "./AddressAutofillList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__